import axios from '@/framework/router/axios'
import _ from 'lodash'
export const check = ['year', 'month', 'week', 'date', 'time', 'datetime', 'daterange', 'timerange', 'datetimerange', 'number']
const mixCalculator = {
  data() {
    return {
      init: 0,
      apiTime: null,
      reqTime: 200,
      erV: null,
      contentItems: []
    }
  },
  methods: {
    async apiCalInit(formData, formId) {
      return axios.post('/flow-simple/calculate/init', formData, {
        params: {
          formId
        }
      })
    },
    async apiCalRun(formData, params) {
      return axios.post('/flow-simple/calculate/run', formData, {
        params: {
          isRecursion: true,
          ...params
        }
      })
    },
    async apiCalRunDynamic(formData, params) {
      return axios.post('/flow-simple/calculate/pop-up-submit', formData, {
        params
      })
    },
    async apiCalRunDynamicAdd({ formData, subFormData }, params) {
      return axios.post('/flow-simple/calculate/pop-up-change', { formData, subFormData }, {
        params
      })
    },
    isReqTime() {
      if (this.apiTime) {
        const currentTime = new Date()
        const prevTiem = this.apiTime
        prevTiem.setMilliseconds(prevTiem.getMilliseconds() + this.reqTime)
        if (currentTime.getTime() > prevTiem.getTime()) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    setLabelPosition(column) {
      column.map(item => {
        const {
          component,
          type,
          label
        } = item
        const isTop = (type === 'dynamic' && component === 'dynamicForm2') || type === 'templateFile'
        if (isTop) {
          item.cplabel = label
          item.label = ''
          item.labelPosition = 'top'
        }
      })
    },
    initDynamicStyle() {
      if (this.viewFormData?.options?.column.length) {
        this.setLabelPosition(this.viewFormData.options.column)
      }
      if (this.viewFormData?.options?.group?.length) {
        const groups = this.viewFormData.options.group
        groups.map(item => {
          this.setLabelPosition(item.column)
        })
      }
    },
    initDynamic() {
      if (this.viewFormData?.options?.column.length) {
        this.initDynamicByColumn(this.viewFormData.options.column)
      }
      if (this.viewFormData?.options?.group?.length) {
        const groups = this.viewFormData.options.group
        groups.map(item => {
          this.initDynamicByColumn(item.column)
        })
      }
    },
    initDynamicByColumn(optionsColumn) {
      const dynamicCols = _.filter(optionsColumn, { type: 'dynamic' })
      dynamicCols.map((dyncol, i) => {
        if (dyncol?.children?.column?.length) {
          const childrenCols = dyncol.children.column
          dyncol.children.rowAdd = (done) => {
            done()
            this.init = 0
            setTimeout(() => {
              this.init = 1
            }, 2000)
          }
          childrenCols.map((itemChild) => {
            if (this.contentIncludes(`${dyncol.prop}.${itemChild.prop}`)) {
              itemChild.change = async({ value, column }) => {
                if (this.init) {
                  const dyncolprop = dyncol.prop
                  const columnprop = column.prop
                  const currentDyn = this.viewFormData.modelData[dyncolprop]
                  let lineNum = null
                  let num = 0
                  let index = null
                  currentDyn.map((item) => {
                    if (item[columnprop] === value) {
                      index = item.$index
                      num += 1
                    }
                  })
                  if (num === 1) {
                    lineNum = index
                  }
                  if (index !== null) {
                    if (this.erV) {
                      this.erV = null
                      return false
                    } else {
                      this.erV = value
                    }
                    await this.runFormData(`${dyncolprop}.${columnprop}`, lineNum)
                  }
                }
              }
            }
          })
        }
      })
    },
    push2Items(item) {
      if (item.formulaType === 'number') {
        item.values.map(str => {
          this.contentItems.push(str.trim())
        })
      } else {
        const {
          firstDateProp,
          secondDateProp
        } = item
        this.contentItems.push(firstDateProp)
        this.contentItems.push(secondDateProp)
      }
    },
    isCalculated() {
      let flag = this.isCalculatedByColumn(this.viewFormData.options.column)
      if (this.viewFormData.options.group) {
        for (var i = 0; i < this.viewFormData.options.group.length; i++) {
          let groupItem = this.viewFormData.options.group[i]
          let tempFlag = this.isCalculatedByColumn(groupItem.column)
          if (tempFlag) {
            flag = tempFlag
          }
        }
      }
      return flag
    },
    isCalculatedByColumn(optionsColumn) {
      const column = optionsColumn.filter(item => {
        const isRight = item.type === 'calculateFormula'
        if (isRight) {
          this.push2Items(item)
        }
        return isRight
      })
      const dynamicCols = optionsColumn.filter(item => item.type === 'dynamic')
      if (dynamicCols.length) {
        let isTrue = false
        dynamicCols.map((dyncol) => {
          if (dyncol?.children?.column?.length) {
            const childrenCols = dyncol.children.column.filter(item => {
              const isRight = item.type === 'calculateFormula'
              if (isRight) {
                this.push2Items(item)
              }
              return isRight
            })
            if (childrenCols.length) {
              isTrue = true
            }
          }
        })
        if (isTrue) {
          return true
        }
      }
      if (column.length) {
        return true
      }
      return false
    },
    // 判断是否触发计算
    contentIncludes(prop) {
      let is = false
      let contentItems = this.contentItems
      if (this.parentContentItems) {
        contentItems = this.parentContentItems
      }
      for (let i = 0; i < contentItems.length; i++) {
        if (contentItems[i] === prop) {
          is = true
          break
        }
      }
      return is
    },
    async initData() {
      if (this.viewFormData.pageKey !== 'DO') {
        return false
      }

      const {
        options,
        modelData
      } = this.viewFormData

      // const column = this.viewFormData.options.column
      let column = []
      this.viewFormData.options.column.forEach(itemColumn => {
        column.push(itemColumn)
      })
      if (this.viewFormData?.options?.group?.length) {
        const groups = this.viewFormData.options.group
        groups.map(item => {
          item.column.forEach(itemColumn => {
            column.push(itemColumn)
          })
        })
      }
      column.map((item, i) => {
        const {
          prop
        } = item
        if (this.contentIncludes(prop)) {
          if (item.change instanceof Function) {
            const oldfn = item.change
            item.change = ({ value, column }) => {
              this.runFormData(column.prop)
              oldfn({ value, column })
            }
          } else {
            item.change = ({ column }) => {
              this.runFormData(column.prop)
            }
          }
        }
      })

      try {
        const { data } = await this.apiCalInit(modelData, options.formId)
        this.setModelData(data)
      } catch ({ msg }) {
        this.$message.error(msg)
      }
    },
    async runFormData(changeField, lineNum = null) {
      const {
        options,
        modelData
      } = this.viewFormData
      const params = {
        changeField,
        formId: options.formId
      }

      // 同时传lineNum=0，1，2会导致计算结果同步问题
      // if (lineNum !== null) {
      //   params.lineNum = lineNum
      // }

      if (!this.isReqTime()) {
        return false
      }

      try {
        const { data } = await this.apiCalRun(modelData, params)
        this.setModelData(data)
        this.apiTime = new Date()
      } catch ({ msg }) {
        this.$message.error(msg)
      }
    },
    setModelData(data) {
      for (let k in data) {
        const val = data[k]
        if (val instanceof Array) {
          const arr = this.viewFormData.modelData[k]
          const arr2 = []
          arr.map((item, i) => {
            const newobj = {
              ...item,
              ...val[i]
            }
            arr2.push(newobj)
          })
          this.viewFormData.modelData[k] = arr2
        } else {
          this.viewFormData.modelData[k] = val
        }
      }
    },
    async runFormData2(propStr) {
      const {
        options,
        modelData
      } = this.viewFormData
      const params = {
        formId: options.formId,
        subProp: propStr
      }
      try {
        const { data } = await this.apiCalRunDynamic(modelData, params)
        this.setModelData(data)
      } catch ({ msg }) {
        this.$message.error(msg)
      }
    },
    async runFormAdd(fieldProp, subProp, subFormData) {
      const {
        options,
        modelData
      } = this.viewFormData

      const params = {
        formId: options.formId,
        subProp,
        fieldProp
      }
      try {
        const { data } = await this.apiCalRunDynamicAdd({
          formData: modelData,
          subFormData
        }, params)
        this.apiTime = new Date()
        return data
      } catch ({ msg }) {
        this.$message.error(msg)
      }
      return null
    },
    isDynamicProp(prop) {
      let str = ''
      let index = null
      const dynamicCols = _.filter(this.viewFormData.options.column, { type: 'dynamic' })

      if (dynamicCols.length) {
        dynamicCols.map((dyncol) => {
          if (dyncol?.children?.column?.length) {
            const childrenCols = dyncol.children.column
            for (let i = 0; i < childrenCols.length; i++) {
              const childCol = childrenCols[i]
              if (childCol.prop === prop) {
                // str = `${dyncol.prop}.${prop}`
                str = dyncol.prop
                index = i
                break
              }
            }
          }
        })
      }
      return {
        str,
        index
      }
    }
  }
}

export default mixCalculator
